<template>
  <CockpitDialog
    title="电视墙模式"
    @closed="close"
    width="85%"
    height="750px"
    top="120px"
    left="160px"
    cardType="horizontal"
    @close="$emit('close')"
  >
    <div class="w-full h-full">
      <!-- <iframe :src="videoWallUrl" frameborder="0" class="w-full h-full" ref="iframe"></iframe> -->
      <div class="h-32px w-full mb-10px pl-25px pr-10px flex items-center">
        <el-input
          v-model="deviceName"
          placeholder="请输入设备名称"
          size="medium"
          clearable
          class="!w-240px ml-1px mr-20px text-12px"
          width="240px"
        />

        <el-button size="medium" type="success" class="mr-20px" @click.native="getVideoList"
          >搜索</el-button
        >
        <el-button size="medium" type="success" class="mr-20px" @click="reset">重置</el-button>
        <!-- 默认6宫格 -->
        <i class="el-icon-menu video-icon" @click.stop="changeSquare(12)" v-if="typeNum === 6"></i>
        <!-- 12宫格 -->
        <i class="el-icon-s-grid video-icon" @click.stop="changeSquare(6)" v-else></i>
      </div>
      <div class="h-[calc(100%-84px)] flex flex-wrap content-start justify-start overflow-hidden">
        <player class="w-full h-full" v-if="showPlayer" :code="cameraCode" :typeNum="typeNum" />
      </div>

      <div class="h-32px w-full mt-10px flex justify-center items-center">
        <el-pagination
          background
          layout="slot, prev, pager, next"
          :total="page.total"
          :page-size="page.pageSize"
          :current-page.sync="page.pageNo"
          @current-change="getVideoList()"
        >
          <template>
            <span>共</span>
            <span>{{ page.total }}</span>
            <span>条数据</span>
          </template>
        </el-pagination>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
// componets
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'

const iotDeviceApi = new IOTDeviceApi()

const player = () => {
  return import('./threeDimMultiPlayer')
}

export default {
  data() {
    return {
      // 分页相关
      page: {
        pageNo: 1,
        pageSize: 6,
        total: 0,
      },
      // 播放器相关
      showPlayer: false,
      cameraCode: [],
      // 搜索相关
      deviceName: '',
      typeNum: 6,
      isThreeDimEntry: false, // 是否是三维监控列表点进来的电视墙模式 默认是数字工地电视墙进入
    }
  },
  props: {
    videoWallVisible: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  components: {
    CockpitDialog,
    player,
  },
  methods: {
    // 获取摄像头列表
    async getVideoList() {
      this.showPlayer = false
      this.cameraCode = []
      const [err, data] = await iotDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: 'Camera',
        keyWord: this.deviceName,
        status: 1,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (!err && data) {
        this.cameraCode = data.items
        this.page.total = data.totalCount
        this.showPlayer = true
      }
    },

    // 重置
    async reset() {
      this.resetData()
      await this.getVideoList()
    },
    resetData() {
      this.page = this.$options.data().page
      this.deviceName = ''
    },

    // 6宫格->12宫格 | 12宫格->4宫格
    async changeSquare(num) {
      this.typeNum = num
      this.page.pageNo = 1
      this.page.pageSize = num
      await this.getVideoList()
    },

    close() {
      if (this.isThreeDimEntry) {
        this.visible = false
        return
      }
      this.$emit('closed')
    },
  },
  computed: {
    visible() {
      return this.videoWallVisible
    },
  },
  watch: {
    videoWallVisible: {
      handler(val) {
        if (val) {
          this.getVideoList()
        } else {
          this.resetData()
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: transparent !important;
}
.video-icon {
  font-size: 32px;
  cursor: pointer;
  color: #fff;
  &:hover {
    color: #558acc;
  }
}
</style>
